<template>
  <div class="access-instructions-config-generation">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-icon><Memo /></el-icon>
          <span>附录</span>
        </div>
      </template>
      <div class="card-content">
        <h2>token生成规则</h2>
        <ul class="aligned-list">
          <li>除token以外的其他参数按参数名升序</li>
          <li>拼接参数值</li>
          <li>追加固定字符串</li>
          <li>整个字符串转大写</li>
          <li>MD5后取32位小写字符串即为token</li>
        </ul>
        <h2>常见错误码</h2>
        <el-table :data="errorCodes" border>
          <el-table-column prop="code" label="错误码"></el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
      </div>
      <!-- 新增导航栏部分 -->
      <div class="access-instructions-footer">
        <router-link to="/access-instructions/file-delete" class="next-document-link">
          <el-icon><ArrowLeft /></el-icon> 文件删除
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { Memo, ArrowLeft } from '@element-plus/icons-vue' // 引入 ArrowLeft 图标
import '@/styles/common-access-instructions.css'

// 定义常见错误码数据
const errorCodes = [
  { code: '40001', description: '参数为空异常' },
  { code: '40002', description: '参数错误' },
  { code: '40003', description: '未知错误' },
  { code: '40004', description: '日期格式不合法' },
  { code: '40005', description: '文件大小超出限制' },
  { code: '40009', description: '请求过于频繁' },
  { code: '40010', description: '文件为空' },
  { code: '40011', description: '可访问标识不合法' },
  { code: '40012', description: 'fosFileId为空' },
  { code: '40013', description: 'objectKey密钥为空' },
  { code: '40014', description: 'objectKey密钥不合法' },
  { code: '40015', description: '设置object密钥异常' },
  { code: '40016', description: '通行密钥不能为空' },
  { code: '40017', description: '生成通行密钥失败' },
  { code: '40018', description: '查询临时密钥列表异常' },
  { code: '40019', description: '生成临时密钥异常' },
  { code: '40020', description: '临时密钥最多只能生成2条' },
  { code: '40021', description: '删除临时密钥异常' },
  { code: '40022', description: '设置临时密钥过期时间异常' },
  { code: '40023', description: '充值异常' },
  { code: '40025', description: '临时凭证有误' },
  { code: '40026', description: '通行密钥或OBJECT密钥不匹配' },
  { code: '40030', description: 'operation传值有误' },
  { code: '40032', description: '图片宽度传值有误' },
  { code: '40041', description: '文件名不能小于2位' },
  { code: '40042', description: '文件格式错误' },
  { code: '40050', description: '未查询到该文件' },
  { code: '40060', description: '文件下载异常' },
  { code: '40061', description: '数据删除失败' },
  { code: '40062', description: '文件不存在' },
  { code: '40063', description: '文件删除失败' },
  { code: '40064', description: '文件对象为空异常' },
  { code: '40065', description: '文件名称不合法' },
  { code: '40066', description: '文件类型不合法' },
  { code: '40067', description: '访问标识不合法' },
  { code: '40070', description: '查询通行密钥失败' },
  { code: '40072', description: '查询object密钥异常' },
  { code: '40101', description: '临时密钥和临时密码有误' },
  { code: '40102', description: '临时密钥已过期，请在平台重新生成' },
  { code: '40103', description: '凭证未设置，请在平台生成' },
  { code: '40104', description: '获取凭证异常' },
  { code: '40112', description: '文件上传异常' },
  { code: '40113', description: '路径查询异常' },
  { code: '40114', description: '未查到该文件' },
  { code: '40115', description: '文件删除异常' },
  { code: '40116', description: '路径列表异常' },
]
</script>

<style scoped>
.access-instructions-config-generation {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.card-content p {
  margin-bottom: 10px;
}

.card-content pre {
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.card-content code {
  font-family: 'Courier New', Courier, monospace;
}

.card-content h2 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.card-content ol {
  padding-left: 20px;
}

/* 新增样式，使列表与h2标题左对齐 */
.aligned-list {
  padding-left: 0;
  list-style-position: inside;
}

/* 新增导航栏样式 */
.access-instructions-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.next-document-link {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>